<div class="px-px-24  py-px-1" style="background: #F3F8FA;">
  <div class=" d-flex align-items-center justify-content-between my-3 flex-wrap">
    <div class="d-flex align-items-center flex-wrap">
      <div class="me-4 inner-add-on left-add-on my-3">
        <input type="search"
               class="form-control w-px-335"
               (input)="searchItem($event)"
               placeholder="Recherche par référence"/>
        <svg-icon class="inner-icon left" svgClass="placeholder-icon" src="/assets/icons/search-grey.svg"></svg-icon>
      </div>
      <div>
        <mat-form-field
          appearance="outline"
          class="d-flex align-items-center w-px-266"
        >
          <mat-label class="fs-16 fw-6"
          ><svg-icon src="/assets/icons/filter.svg"></svg-icon> Statut
            mission</mat-label
          >
          <mat-select multiple (selectionChange)="handleStatusChange($event)">
            @for (item of filterListDone; track item) {
              <mat-option [value]="item?.value">
                {{ item?.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="card-container p-px-8 quick-filter-etablissements" *ngIf="siteList.length">
      @for (item of siteList;track item.id) {
        <app-filter-tag [text]="item.name" bgColor="white" color="white"
                        [chipSelected]="selectedSite === item.id"
                        (handleClick)="toggleSelectSite($event, item)"></app-filter-tag>
      }
    </div>
  </div>

  <app-data-table
    [isLoading]="isLoading"
    [dataSource]="missionListFiltered"
    [columns]="customColumns"
    (onFullRowClick)="handleRowClick($event)"
    [hasRowAction]="true"
    [showSideBar]="true"
    [component]="component"
    [totalItems]="totalItemsAfterFilter"
    (nextPage)="pagination($event)"
    [pageSize]="size"
    [pageIndex]="offset"
  ></app-data-table>
</div>
